import {TERMS_OF_SERVICE_PATH_PATTERN} from '../coches/page'

export const USER_CONSENT_STORAGE_KEY = 'fsc'

export const USER_CONSENTS = {
  FINANCIAL_SERVICES: 'financial_services',
  WHATSAPP_COMMUNICATIONS_C2B: 'whatsapp_communications_C2B',
  PORTAL_ANNOUNCEMENTS: 'portal_announcements',
  EXTERNAL_SERVICES_OFFERS: 'external_services_offers',
  SEGMENTED_ADS: 'segmented_ads'
}

export const ENABLED_USER_PROFILE_CONSENTS = [
  USER_CONSENTS.PORTAL_ANNOUNCEMENTS,
  USER_CONSENTS.EXTERNAL_SERVICES_OFFERS,
  USER_CONSENTS.SEGMENTED_ADS
]

/**
 * @enum Lead hit type
 */
export const LEAD_HIT_TYPES = {
  VIEW_AD_PHONE: 1,
  VIEW_DEALER_PHONE: 2,
  CALL_AD: 3,
  CALL_DEALER: 4
}

export const SUBSCRIPTIONS = {
  EXTERNAL_SERVICES_OFFERS: 'external_services_offers',
  PORTAL_ANNOUNCEMENTS: 'portal_announcements'
}

export const CONSENT_LINK_PRICEDROP_ENABLED = false

export const DATA_MANAGEMENT_URL = 'https://motosnet.zendesk.com/hc/es/sections/6713622782994-Sobre-tus-datos'

export const CONSENT_EXTERNAL_SERVICES_INFO_URL = `${TERMS_OF_SERVICE_PATH_PATTERN}/#privacidad`
export const CONSENT_FINANCIAL_SERVICES_INFO_URL = `${TERMS_OF_SERVICE_PATH_PATTERN}/#personal-data-handling`
export const CONSENT_SEGMENTED_ADS_INFO_URL = `${TERMS_OF_SERVICE_PATH_PATTERN}/#privacidad`

export const ACCOUNT_VERIFICATION_REMINDER_ENABLED = false

export const UPDATE_USER_AVATAR_ENABLED = false

export const USER_PHONE_VERIFICATION_ENABLED = false

export const PROFESSIONAL_SELLER_LOGIN_URL = 'https://pro.motos.net/login.aspx'
